// PB-1920: a custom maturity must only ever be used while the CUSTOM schedule
// is selected.
//
// `customMaturity` is set from MultiInterestPayout's onPayoutChange payload and
// is *not* cleared by every route that leaves the CUSTOM schedule (see the
// emitters that omit `maturityDateTime` entirely). Reading it unconditionally
// when building the order therefore lets a maturity chosen under CUSTOM leak
// into an order booked under a different schedule — the PB-1920 defect.
//
// This lives in libs/ rather than in a page module because investcc.js,
// investdpl.js and investloan.js all need it: importing it from a sibling page
// would drag that entire page component (and its whole dependency chain) into
// the other pages' bundles for the sake of a three-line predicate.
export const resolveMaturityForOrder = (
  payoutSchedule,
  customMaturity,
  productDefaultEndDate
) =>
  payoutSchedule === 'CUSTOM' && customMaturity
    ? customMaturity
    : productDefaultEndDate;

// The tenor counterpart of the rule above. Kept beside it so the two halves of
// the same guard cannot drift apart: `customMaturityDaysLeft` lands in the
// order as `tenor`, which the backend divides termAPY by to derive
// treasury_rate, so a stale value here is as damaging as a stale maturity.
export const resolveDaysLeftForOrder = (
  payoutSchedule,
  customMaturityDaysLeft,
  productDefaultDaysLeft
) =>
  payoutSchedule === 'CUSTOM' && customMaturityDaysLeft !== null
    ? customMaturityDaysLeft
    : productDefaultDaysLeft;
